module.exports = new __parcel__URL__("pve_victory_bg.98690f6c.png").toString();